import IconComponent from "icons/IconComponent";

import ForwardIcon from "./forward.svg";

export default (ForwardIcon as any) as IconComponent;
